import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class NominatimService {
	constructor(private genericCrudService: GenericCrudService) {}

	addressLookup(req?: any): Observable<any> {
		const url = `https://api-adresse.data.gouv.fr/search/?q=${req}&limit=15`;
		return this.genericCrudService.genericGetAPIData(
			url,
			'getAdressFromApiAdresseDataGouv'
		);
	}

	regionCodeLookup(req?: any): Observable<any> {
		const url = `https://geo.api.gouv.fr/communes?codePostal=${req}`;
		return this.genericCrudService.genericGetAPIData(
			url,
			'getRegionCodeFromGeoApiGouv'
		);
	}

}
